export default __webpack_public_path__ + "./images/kn.0c454771.png";